import React from 'react';
import { Menu, Dropdown, Avatar } from 'antd';
import { connect } from 'react-redux';
import { LogoutOutlined } from '@ant-design/icons';
import { signOut } from 'redux/actions/Auth';

export const NavProfile = ({ signOut }) => {
  const profileImg = '/img/avatars/thumb-1.png';

  return (
    <Dropdown
      placement="bottomRight"
      menu={{
        onClick: ({ key }) => {
          if (key === 'sign-out') {
            signOut();
          }
        },

        items: [
          {
            key: 'sign-out',
            label: (
              <div>
                <LogoutOutlined className="mr-3" />
                Sign Out
              </div>
            ),
          },
        ],
      }}
      trigger={['click']}
    >
      <Menu
        className="d-flex align-item-center"
        mode="horizontal"
        items={[
          {
            key: 'profile-avatar',
            label: <Avatar src={profileImg} />,
          },
        ]}
      />
    </Dropdown>
  );
};

export default connect(null, { signOut })(NavProfile);
